import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';

Vue.use(Vuex);

function saveWineDatabase(data) {
    localStorage.setItem('weintage-database', JSON.stringify(data));
}

function getWineDatabase() {
    let data = localStorage.getItem('weintage-database');

    if (data !== null) {
        data = JSON.parse(data);
    }

    return data;
}

function saveWineList(wineList) {
    localStorage.setItem('wine-list', JSON.stringify(wineList));
}

function getWineList() {
    let data = localStorage.getItem('wine-list');

    return data !== null ? JSON.parse(data) : [];
}

const store = new Vuex.Store({
    state: {
        menuVisible: false,
        database: getWineDatabase(),
        wineList: getWineList()
    },

    mutations: {
        showMenu(state) {
            state.menuVisible = true;
        },

        hideMenu(state) {
            state.menuVisible = false;
        },

        setData(state, data) {
            state.database = data;
        },

        addWineToList(state, wine) {
            state.wineList.push({
                wineId: wine.id,
                note: ''
            });
        },

        removeWineFromList(state, wine) {
            state.wineList = state.wineList.filter(item => item.wineId !== wine.id);
        },

        emptyWineList(state) {
            state.wineList = [];
        },

        setNoteOnWineList(state, {wine, note}) {
            let index = state.wineList.findIndex(item => item.wineId === wine.id);

            state.wineList[index].note = note;
        }
    },

    getters: {
        grapeType(state) {
            return id => {
                if (state.database === null) {
                    return null;
                }

                return state.database.grapetypes.find(grapeType => grapeType.id === id);
            };
        },

        wineBuildup(state) {
            return id => {
                if (state.database === null) {
                    return null;
                }

                return state.database.winebuildups.find(wineBuildup => wineBuildup.id === id);
            };
        },

        wineQuality(state) {
            return id => {
                if (state.database === null) {
                    return null;
                }

                return state.database.winequalities.find(wineQuality => wineQuality.id === id);
            };
        },

        wineTaste(state) {
            return id => {
                if (state.database === null) {
                    return null;
                }

                return state.database.winetastes.find(wineTaste => wineTaste.id === id);
            };
        },

        wineType(state) {
            return id => {
                if (state.database === null) {
                    return null;
                }

                return state.database.winetypes.find(wineType => wineType.id === id);
            };
        },

        wineries(state, getters) {
            if (state.database === null) {
                return [];
            }

            let wineries = state.database.users.map(user => {
                let winery = user.user.customer;

                winery.themeWineId = user.theme_wine_id ? Number.parseInt(user.theme_wine_id) : 0;
                winery.standnummer = user.standnummer ? Number.parseInt(user.standnummer) : 0;

                winery.wines = user.wines.map(wine => {
                    wine.grapeType = getters.grapeType(wine.grapetype_id);
                    wine.wineBuildup = getters.wineBuildup(wine.winebuildup_id);
                    wine.wineQuality = getters.wineQuality(wine.winequality_id);
                    wine.wineTaste = getters.wineTaste(wine.winetaste_id);
                    wine.wineType = getters.wineType(wine.winetype_id);
                    wine.winerySearchData = {
                        title: winery.title,
                        city: winery.city,
                        address: winery.address,
                        firstname: winery.firstname,
                        lastname: winery.lastname
                    };

                    return wine;
                });

                return winery;
            });

            wineries.sort((a, b) => a.standnummer - b.standnummer);

            return wineries;
        },

        wines(state, getters) {
            return getters.wineries
                .map(winery => winery.wines)
                .reduce((allWines, wines) => allWines.concat(wines));
        },

        wine(state, getters) {
            return id => getters.wines.find(wine => wine.id === id);
        },

        getNote(state) {
            return id => {
                let index = state.wineList.findIndex(item => item.wineId === id);

                if (index >= 0) {
                    return state.wineList[index].note;
                }

                return null;
            };
        }
    },

    actions: {

    }
});

store.watch(
    (state) => state.wineList,
    (newWineList) => {
        saveWineList(newWineList);
    },
    {
        deep: true
    }
);

axios
    //.get('https://weindb.suedlicheweinstrasse.de/export/appData/86') // 2018
    //.get('https://weindb.suedlicheweinstrasse.de/export/appData/87') // 2019
    //.get('https://weindb.suedlicheweinstrasse.de/export/appData/88') // 2021
    //.get('https://weindb.suedlicheweinstrasse.de/export/appData/89') // 2022
    //.get('https://weindb.suedlicheweinstrasse.de/export/appData/90') // 2023
    // .get('https://weindb.suedlicheweinstrasse.de/export/appData/91') // 2024
    // .get('https://weindb.suedlicheweinstrasse.de/export/appData/93') // 2025
    .get('https://weindb.suedlicheweinstrasse.de/export/appData/95') // 2026
    .then(result => {
        let data = result.data;
        let users = [];

        for (let id in data.users) {
            users.push(data.users[id]);
        }

        data.users = users;

        saveWineDatabase(data);
        store.commit('setData', data);
    });

export default store;
